"use client";

import Link from "@/infrastructure/router/Link";
import { useEffect, useState } from "react";
import { useArtistSession } from "@/components/auth/ArtistSessionProvider";
import {
	browserDiscoveryRepository,
	type DiscoveryRepository,
	type Inspiration,
} from "@/domain/discovery/DiscoveryRepository";
import { DiscoveryArtwork } from "./DiscoveryPrimitives";

export function InspirationDetail({
	id,
	repository = browserDiscoveryRepository,
}: Readonly<{ id: string; repository?: DiscoveryRepository }>) {
	const auth = useArtistSession();
	const [idea, setIdea] = useState<Inspiration | null | undefined>(undefined);
	const [error, setError] = useState(false);
	useEffect(() => {
		if (auth.phase === "loading") return;
		let active = true;
		repository
			.loadInspiration(id, auth.scope)
			.then((value) => {
				if (active) setIdea(value);
			})
			.catch(() => {
				if (active) setError(true);
			});
		return () => {
			active = false;
		};
	}, [auth.phase, auth.scope, id, repository]);
	if (error)
		return (
			<section className="state-panel state-panel--hero" role="alert">
				<strong>灵感加载失败</strong>
				<p>返回灵感列表后重试。</p>
				<Link href="/discover">返回发现</Link>
			</section>
		);
	if (idea === undefined)
		return (
			<p className="inline-status" role="status">
				正在打开灵感…
			</p>
		);
	if (idea === null)
		return (
			<section className="state-panel state-panel--hero">
				<strong>没有这条灵感</strong>
				<Link href="/discover">返回发现</Link>
			</section>
		);
	return (
		<article className="inspiration-detail">
			<DiscoveryArtwork tone={idea.artwork} label={idea.title} />
			<div>
				<p className="eyebrow">INSPIRATION / {idea.id.toUpperCase()}</p>
				<h1>{idea.title}</h1>
				<blockquote>{idea.prompt}</blockquote>
				<p>{idea.note}</p>
				<div>
					<Link
						className="primary-action"
						href={`/genart?prompt=${encodeURIComponent(idea.prompt)}`}
					>
						用它开始创作
					</Link>
					<Link className="secondary-action" href="/discover">
						返回灵感
					</Link>
				</div>
			</div>
		</article>
	);
}
